<template>
  <div class="UserSelect-container">
    <el-select
      v-model="value"
      ref="select"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchUser"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-tree
          ref="tree"
          :data="treedata"
          node-key="value"
          :props="defaultProps"
          :filter-node-method="filterNode"
          @node-click="handleCheckChange">
          <span style="font-weight: 400;padding: 5px 0;" slot-scope="{ node, data }">
              <el-avatar size="small" style="vertical-align: middle;" :src="data.icon" v-if="data.disabled===false"></el-avatar>
              <span style="vertical-align: middle;margin-left: 6px;">{{ node.label }}</span>
          </span>
        </el-tree>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getStaffUserTree } from '@/api/pub'

export default {
  name: 'UserSelect',
  props: {
    groupid: {
      type: Number
    },
    userid: {
      type: Number,
      default: ''
    },
    set: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      filterText: '',
      value: '',
      changeLabel: '',
      treedata: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        disabled: 'disabled'
      }
    }
  },
  created() {
    let gid = ''
    if (this.groupid != null) {
      gid = this.groupid
    }
    let uid = ''
    if (this.set != null) {
      uid = this.set
    }
    getStaffUserTree({ groupid: gid, setid: uid, userid: this.userid }).then(response => {
      this.treedata = response.data.userlist
      if (response.data.setid != null) {
        this.value = response.data.setid
        this.changeLabel = response.data.setname
        this.$emit('input', this.value)
        this.$emit('change', { id: this.value, name: this.changeLabel })
      }
    }).catch(() => {})
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', this.value)
      for (let i = 0; i < this.treedata.length; i++) {
        this.$refs.tree.store.nodesMap[this.treedata[i].value].expanded = false
      }
    },
    searchUser(val) {
      this.filterText = val
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleCheckChange(data) {
      if (!data.disabled) {
        this.value = parseInt(data.value)
        this.changeLabel = data.label
        this.$emit('input', this.value)
        this.$emit('change', { id: this.value, name: this.changeLabel })
        this.$refs.select.blur()
        this.filterText = ''
        for (let i = 0; i < this.treedata.length; i++) {
          this.$refs.tree.store.nodesMap[this.treedata[i].value].expanded = false
        }
      }
    }
  }
}
</script>
